export default "__VITE_ASSET__CJckc91L__"